import RemoveIcon from "@mui/icons-material/Remove";
import FreeLine from "./FreeLine";

class Line extends FreeLine {

	id = "Line";
	name = "Line";
	icon = <RemoveIcon sx={{transform: "rotate(-45deg) scale(1.4)"}}/>;
	freehand = false;
	maxPoints = 2;
	shortcutKey = "1";
	className='Line-forTour'
}

export default Line;
